import type { BorrowMarketAssetData, BorrowMarketDetail } from '@/utils/internalAppSdk'
import { getBorrowMarketCollateralSizeUsd } from './getBorrowMarketCollateralSizeUsd'

export const getSortedBorrowMarketCollateralPairs = ({
  market,
  borrowAssetData,
}: {
  market: BorrowMarketDetail
  borrowAssetData: BorrowMarketAssetData
}) =>
  market.pairs
    .filter(
      (pair) =>
        pair.borrowMarketAssetId === borrowAssetData.marketAssetId && pair.collateralEnabled && pair.borrowEnabled
    )
    .sort(
      (a, b) =>
        getBorrowMarketCollateralSizeUsd(market, b.collateralMarketAssetId) -
        getBorrowMarketCollateralSizeUsd(market, a.collateralMarketAssetId)
    )
